import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";

import "./css/components.css";
import { buscarUnidad, listarContaminantes } from "../api/General";
import { isInvalid } from "../utils/forms";
import { crearDucto } from "../utils/data";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import QuestionField from "./controls/QuestionField";
import ArrayField from "./controls/ArrayField";
import { DuctoForm } from "./DuctoForm";
import { DuctoList } from "./DuctoList";

export default function FuentesFijasForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const unidadDiasCatalog = useCatalog(["unidad", "DSEM"], () =>
    buscarUnidad("DSEM"),
  );
  const unidadMesesCatalog = useCatalog(["unidad", "MESANIO"], () =>
    buscarUnidad("MESANIO"),
  );
  const unidadHorasCatalog = useCatalog(["unidad", "HSEM"], () =>
    buscarUnidad("HSEM"),
  );
  const unidadSeccionCatalog = useCatalog(["unidad", "M2"], () =>
    buscarUnidad("M2"),
  );
  const unidadMetroCatalog = useCatalog(["unidad", "M"], () =>
    buscarUnidad("M"),
  );
  const unidadTemperaturaCatalog = useCatalog(["unidad", "K"], () =>
    buscarUnidad("K"),
  );
  const unidadVelocidadCatalog = useCatalog(["unidad", "MS"], () =>
    buscarUnidad("MS"),
  );
  const unidadCaudalCatalog = useCatalog(["unidad", "M3H"], () =>
    buscarUnidad("M3H"),
  );
  const contaminantesCatalog = useCatalog(
    ["contaminantes", "GASEOSO"],
    () => listarContaminantes({ estado: "GASEOSO" }),
  );
  const loading =
    unidadDiasCatalog.loading ||
    unidadMesesCatalog.loading ||
    unidadHorasCatalog.loading ||
    unidadSeccionCatalog.loading ||
    unidadMetroCatalog.loading ||
    unidadTemperaturaCatalog.loading ||
    unidadVelocidadCatalog.loading ||
    unidadCaudalCatalog.loading ||
    contaminantesCatalog.loading;
  const handleConChimeneasChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleChimeneasChange = (event) => {
    tramiteForm.handleChange(event);
  };
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col>
            <QuestionField
              id="conChimeneas"
              name="conChimeneas"
              label={t("tramite.conChimeneas")}
              value={tramiteForm.values.conChimeneas}
              onChange={handleConChimeneasChange}
              isInvalid={isInvalid("conChimeneas", tramiteForm)}
              error={tramiteForm.errors.conChimeneas}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="chimeneas"
              name="chimeneas"
              label={t("tramite.chimeneas")}
              value={tramiteForm.values?.chimeneas}
              onChange={handleChimeneasChange}
              createItem={crearDucto}
              isInvalid={isInvalid("chimeneas", tramiteForm)}
              error={
                (tramiteForm.errors.chimeneas instanceof Array &&
                  t("errors.tramite.chimeneas.many")) ||
                t(tramiteForm.errors.chimeneas)
              }
              disabled={
                !isEditable(tramite) || !tramiteForm.values.conChimeneas
              }
            >
              {({
                value: ductos,
                append,
                remove,
                replace,
                select,
                selectedItem,
                selectedIndex,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <DuctoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={ductos.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          contaminantes={contaminantesCatalog.data}
                          operacionesUnitarias={
                            tramiteForm.values.operacionesUnitarias
                          }
                          unidadAltura={unidadMetroCatalog.data}
                          unidadCaudal={unidadCaudalCatalog.data}
                          unidadDiametro={unidadMetroCatalog.data}
                          unidadHoras={unidadHorasCatalog.data}
                          unidadDias={unidadDiasCatalog.data}
                          unidadMeses={unidadMesesCatalog.data}
                          unidadSeccion={unidadSeccionCatalog.data}
                          unidadTemperatura={unidadTemperaturaCatalog.data}
                          unidadVelocidadSalida={unidadVelocidadCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <DuctoList
                        value={ductos}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
